export const LABELS_VALIDATION_ERROR_MESSAGE = 'Cannot add more than 10 event labels';
export const EVENT_MAXIMUM_NUMBER_OF_LABELS = 10;

// Breakpoints

export const dexClearFormButtonBreakpoint = 200;
export const dexSendButtonBreakpoint = 300;
export const dexSendAndClearFormButtonBreakpoint = 400;

export const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];

export const USX_LABEL = 'Universal Search';
export const DEX_LABEL = 'DEx';

export const DEFAULT_EVENT_LOCATION_NOTIFICATIONS_CLEAR_DELAY_MS = 5000;
